import { Editor, useEditorState } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { IconLabel } from '../../../IconLabel';

import classNames from 'classnames';
import classes from '../InlineTools.module.scss';

interface BoldProps {
  editor: Editor;
}

export const Bold: FunctionComponent<BoldProps> = ({ editor }) => {
  const { t } = useTranslation();

  const { isActive, canToggle } = useEditorState({
    editor,
    selector: ({ editor }) => ({
      isActive: editor.isActive('bold'),
      canToggle: editor.can().chain().focus().toggleBold().run(),
    }),
  });

  return (
    <IconLabel
      iconId={'bold'}
      iconSize={16}
      ariaLabel={t('richTextEditor.tool-names-bold')}
      onClick={() => editor.chain().focus().toggleBold().run()}
      disabled={!canToggle}
      className={classNames(classes['inline-tools__item'], {
        [classes['inline-tools__item--active']]: isActive,
        [classes['inline-tools__item--disabled']]: !canToggle,
      })}
    />
  );
};
